import { InlineUser } from "@/components";
import { IProjectRole } from "@/interfaces";
import { Card, Col, Row, Typography } from "antd";
import { FormattedDate, FormattedTime, useIntl } from "react-intl";

interface IProps {
  role: IProjectRole;
}

export const ProjectRoleHistory = ({ role }: IProps) => {
  const intl = useIntl();
  return (
    <Card
      title={intl.formatMessage({ id: "general.history" })}
      className="h-full"
      loading={!role}
    >
      {(role?.createdBy || role?.createdAt) && (
        <>
          <Row className="pb-2">
            <Col>
              <Typography.Text strong>
                {intl.formatMessage({ id: "projectRoles.created" })}
              </Typography.Text>
              <div>
                <InlineUser userId={role.createdBy || ""} />
                {" @ "}
                <FormattedDate value={role.createdAt} />{" "}
                <FormattedTime value={role.createdAt} />
              </div>
            </Col>
          </Row>
          <Row className="pb-2">
            <Col>
              <Typography.Text strong>
                {intl.formatMessage({ id: "projectRoles.updated" })}
              </Typography.Text>
              <div>
                <InlineUser userId={role.updatedBy || ""} />
                {" @ "}
                <FormattedDate value={role.updatedAt} />{" "}
                <FormattedTime value={role.updatedAt} />
              </div>
            </Col>
          </Row>
        </>
      )}
    </Card>
  );
};
